import {
  CampoEstraibileCSV,
  EnumCampoEstraibileCSVOrigineCampoCompilabile,
} from '@framework/api-client';

export type ExportFileField = CampoEstraibileCSV;

export type ExportFileType = 'geojson' | 'csv' | 'xlsx';
export type ExportFileEntity = 'procedimenti' | 'attività';

export type ExtractableFileFieldOrigin =
  EnumCampoEstraibileCSVOrigineCampoCompilabile;
export const ExtractableFileFieldOrigins =
  EnumCampoEstraibileCSVOrigineCampoCompilabile;
